import React from 'react';

export const Pencil = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13">
            <path d="m11.8 4.5.738-.738a1.55 1.55 0 0 0 0-2.2l-1.1-1.1a1.55 1.55 0 0 0-2.2 0L8.5 1.2ZM7.393 2.3.156 9.537A.511.511 0 0 0 0 9.912v2.568a.515.515 0 0 0 .52.52h2.568a.488.488 0 0 0 .364-.156l7.237-7.237Z" />
        </svg>
    );
}
